/* eslint-disable camelcase */
import { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import * as Routes from '@constants/routes';
import { getObjectRefund } from '@helpers';
import { doRefund } from '@services/transactions-service';
import {
  hideLoading,
  setCurrentRefund,
  showLoading,
  fetchRefunds,
} from '@store/transactions/actions';

export const ERROR_INSUFFICIENT_BALANCE = 'RFD-01'; // message: 'Error Balance Available'
export const ERROR_INSUFFICIENT_BALANCE_TOMORROW = 'RFD-02';
export const ERROR_TRANSACTION_ALREADY_REFUNDED = 'RFD-03'; // message: 'Transaction already refunded'
export const CMR_POINTS = 'CMR_POINTS';
// FIXME: depreacar en favor de useTransaction.
// La convención acordad es tener un hook por cada store de redux.
const useRefund = () => {
  const {
    currentTransaction,
    dataRefunds: refunds,
    isLoading,
    originalTransactionSaleAmount,
  } = useSelector((state) => state.transactions);
  const history = useHistory();
  const {
    merchant: { _id, wallet_info },
  } = useSelector((state) => state.login);
  const dispatch = useDispatch();
  const [amount, setAmount] = useState(0);
  const [isLittleGrossValue, setIsLittleGrossValue] = useState(false);
  const [errorBalance, setErrorBalance] = useState(null);
  const [errorTransactionAlreadyRefunded, setErrorTransactionAlreadyRefunded] = useState(null);

  useEffect(() => {
    setIsLittleGrossValue(amount > currentTransaction?.gross_value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [amount]);

  const refund = (refundAmount) => {
    dispatch(showLoading());
    const { merchant_id } = wallet_info;
    const refundObject = getObjectRefund(
      _id,
      currentTransaction?.authorization_id,
      refundAmount || amount,
      merchant_id,
      currentTransaction?.status,
      currentTransaction?.details_transaction
    );
    doRefund(refundObject)
      .then(({ operations, user, transactionInfo }) => {
        dispatch(setCurrentRefund(operations, user, currentTransaction, transactionInfo));
        history.push(`${Routes.SUCCESS_REFUND}?t=${currentTransaction.authorization_id}`);
      })
      .catch((e) => {
        const { state } = refundObject;
        if (e?.error && e?.error.code === ERROR_INSUFFICIENT_BALANCE) {
          setErrorBalance(ERROR_INSUFFICIENT_BALANCE);
        } else if (e?.error && e?.error.code === ERROR_INSUFFICIENT_BALANCE_TOMORROW) {
          setErrorBalance(ERROR_INSUFFICIENT_BALANCE_TOMORROW);
        } else if (state === 'reversed' || state === 'rejected') {
          setErrorTransactionAlreadyRefunded(ERROR_TRANSACTION_ALREADY_REFUNDED);
        } else {
          history.push(Routes.ERROR_REFUND, {
            fraudError: e?.fraud_assesment_code === 1000,
            messageCode: e.message_code,
          });
        }
      })
      .finally(() => dispatch(hideLoading()));
  };

  const getRefunds = useCallback(
    (saleAuthorizationId, eventDate) => dispatch(fetchRefunds(saleAuthorizationId, eventDate)),
    [dispatch]
  );

  return {
    amount,
    errorBalance,
    isLittleGrossValue,
    isLoading,
    originalTransactionSaleAmount,
    refunds,
    transaction: currentTransaction,
    getRefunds,
    refund,
    setAmount,
    setErrorBalance,
    setErrorTransactionAlreadyRefunded,
    errorTransactionAlreadyRefunded,
  };
};

export default useRefund;
